const store = {
    namespaced: true,
    state: {
        categories: []
    },
    getters: {
        getCategories: state => state.categories
    },
    mutations: {
        SET_CATEGORIES(state, categories) {
            state.categories = categories;
        }
    },
    actions: {
        async fetchCategories({ commit }) {
            try {
                const response = await this.$axios.$get(`/general/category-products-main-page/`);
                commit('SET_CATEGORIES', response);
            } catch (error) {
                console.log(error);
            }
        }
    }
};

export default store;
